// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2EOTV","header":"MergedInvoice_header__14twY"};